import { render, staticRenderFns } from "./Assistance.vue?vue&type=template&id=8b17d696&scoped=true&lang=html&"
import script from "./Assistance.vue?vue&type=script&lang=js&"
export * from "./Assistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b17d696",
  null
  
)

export default component.exports